import { render, staticRenderFns } from "./BaseTlmkt.vue?vue&type=template&id=51379164"
import script from "./BaseTlmkt.vue?vue&type=script&lang=js"
export * from "./BaseTlmkt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports